import "./StudyPlaner.css";
import React, { useState } from "react";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-calendars/styles/material.css";
import { TimePickerComponent } from "@syncfusion/ej2-react-calendars";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import StudyPlannerMultiple from "../Multiple Study Planner/StudyPlannerMultiple";
import axios from "../../../../axios";
import { useEffect } from "react";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import SucessfullyPublished from "./SucessFullyPublished";
import StudyPlannerDatePopup from "./StudyPlannerDatePopup";
export default function StudyPlaner({
  studyPlannerDeactive,
  studentDetails,
  value,
}) {
  //Here added code for set the Datepicker range
  const today = new Date();
  new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  }
  const [studyPlanner, setStudyPlanner] = useState({
    selectDay: false,
  });
  const [input, setInput] = useState("");
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const [isSucess, setIsSucess] = useState(false);
  const [isClickedOnCreated, setIsClickedOnCreated] = useState("");
  const [resErrorMessage, setresErrorMessage] = useState("")
  const [sTime, setSTime] = useState("")
  const [eTime, setETime] = useState("")

  const handleSelectDayClick = () => {
    setStudyPlanner(studyPlanner.selectDay);
    if (studyPlanner.selectDay) {
      setStudyPlanner({
        ...studyPlanner,
        selectDay: false,
      });
    } else {
      setStudyPlanner({
        ...studyPlanner,
        selectDay: true,
      });
    }
  };
  localStorage.setItem("dropdownval", "0");
  // all days code
  const [selectedDays, setSelectedDays] = useState([]);
  const handleDayClick = (day) => {
    if (selectedDays.includes(day)) {
      setSelectedDays(
        selectedDays.filter((selectedDay) => selectedDay !== day)
      );
    } else {
      setSelectedDays([...selectedDays, day]);
    }
  };

  const handleAllDaysClick = () => {
    if (selectedDays.length === 7) {
      setSelectedDays([]);
    } else {
      setSelectedDays([
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ]);
    }
  };

  // start time end time
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedEndTime, setSelectedEndTime] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  const [overlap, setOverlap] = useState(false);
  const [repeat, setRepeat] = useState(true);
  const [nameError, setNameError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [date, setDate] = useState("");
  const [showPopup, setShowPop] = useState(false)
  const [validateInputMessage, setValidateInputMessage] = useState('')
  const handleTimeChange = (time) => {
    if (selectedEndTime && time >= selectedEndTime) {
      setErrorMessage("Error! Start time cannot be after or equal to end time.");
      return;
    }

    setSelectedTime(time);
    setErrorMessage("");
  };

  const handleEndTimeChange = (endTime) => {
    if (selectedTime && endTime <= selectedTime) {
      setErrorMessage("Error! Start time cannot be after or equal to end time.");
      return;
    }
    setSelectedEndTime(endTime);
    setErrorMessage("");
  };
  const handleInputChnage = (para) => {
    setInput(para);
  };
  const handleInputName = (para) => {
    if (para.length <= 20) {
      setName(para);
      setNameError(false);
      setErrorMessage(null);

    } else {
      setNameError(true);
      setErrorMessage("Study Planner name should not extend 275 character.");
    }
  };

  const handleInputDescription = (para) => {
    if (para.length <= 2450) {
      setDescription(para);
      setDescriptionError(false);
      setErrorMessage(null);
    } else {
      setDescriptionError(true);
      setErrorMessage(
        "Study Planner description should not extend 2450 character."
      );
    }
  };
  useEffect(() => {
    axios
      .get(
        `/school/standardId/${studentDetails.standard.id}/sectionId/${studentDetails.section.id}/getSubjects`
      )
      .then((res) => {
        setSubjectList(res.data.data.subjects);
      });
  }, []);
  function formatTime(input) {
    const date = new Date(input);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return formattedHours + formattedMinutes;
  }
  const handleStudyPlannerPublished = async () => {
    let body;
    if (repeat) {
      body = {
        academic_year_id: studentDetails.academic_year.id,
        school_id: studentDetails.school.id,
        standard_id: studentDetails.standard.id,
        section_id: studentDetails.section.id,
        student_id: studentDetails.id,
        timetable_session_id: studentDetails.timetable_session.id,
        start: formatDate(sDate),
        end: formatDate(eDate),
        schedules: {
          lectures: [
            {
              name: name,
              description: description,
              start_time: formatTime(sTime),
              end_time: formatTime(selectedEndTime),
              subject_id: input,
              day: selectedDays,
              recurrence: true,
            },
          ],
        },
      };
    } else {
      body = {
        academic_year_id: studentDetails.academic_year.id,
        school_id: studentDetails.school.id,
        standard_id: studentDetails.standard.id,
        section_id: studentDetails.section.id,
        student_id: studentDetails.id,
        timetable_session_id: studentDetails.timetable_session.id,
        start: formatDate(date),
        schedules: {
          lectures: [
            {
              name: name,
              description: description,
              start_time: formatTime(sTime),
              end_time: formatTime(selectedEndTime),
              subject_id: input,
              date: formatDate(date),
              recurrence: false,
            },
          ],
        },
      };
    }

    try {
      setIsClickedOnCreated(true);
      let res = await axios.post(`/studyPlanner/createByDate`, body);
      if (res.status === 200 || res.status === 201) {
        setIsClickedOnCreated(false);
        // window.location.reload();
        setIsSucess(true);
      }
    } catch (error) {
      setIsClickedOnCreated(false);
      setShowPop(true);
      if (error.response && error.response.data && error.response.data.message) {
        setresErrorMessage(error.response.data.message);
      }
      // if (
      //   error.response.data.message ===
      //   "StudyLecture has a overlapping time. Please check and update the time of overlapped lecture."
      // ) {
      //   setOverlap(true);
      // }
      console.log(error);
    }
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  const handleValidateInputfield = () => {
    if (
      !input ||
      (repeat && (!sDate || !eDate)) ||
      !selectedTime ||
      !selectedEndTime ||
      (!repeat && !date) ||
      !name ||
      !description
    ) {
      setValidateInputMessage("This is a required field.");
      return false;
    }
    return true;
  };

  const getNextDay = (date) => {
    const next = new Date(date);
    next.setDate(next.getDate() + 1);
    return next;
  };

  return !overlap ? (
    <div className="ContainerStudyPlaner">
      {!isSucess && <div className="SubContainerStudyPlaner p-4">
        <div className="studyplanner">Create Study Planner</div>
        <div className="">
          <select
            className="plannerSubject mt-3 p-2"
            onChange={(e) => {
              handleInputChnage(e.target.value);
            }}
            value={input}
          >
            <option value=''>Select Subject</option>
            {subjectList.map((obj) => (
              <option value={obj.id}>{obj.name}</option>
            ))}
          </select>
          <div className="errormessage">{validateInputMessage}</div>
        </div>
        <div className="d-flex gap-3 mt-1 mb-1">
          <div className="pl-4">
            <input
              className="form-check-input mr-2"
              type="checkbox"
              checked={repeat}
              onChange={(e) => {
                setRepeat(!repeat);
                setSDate(null)
                setEDate(null)
              }}
              // id="inlineCheckbox1"
              value="option1"
            ></input>
            <span className="rpt">Repeat</span>
          </div>
        </div>
        {/* for repeat drop */}
        {repeat && (
          <div className="mainRpt ">
            <div className="selectTimeContainer1  d-flex align-items-center" style={{ zIndex: "auto" }}>
              {/* <div className="d-flex   justify-content-between"> */}
              <DatePickerComponent
                placeholder="From Date"
                className="clr"
                width={300}
                value={sDate}
                min={today}
                isDateDisabled={disablePastDates}
                onChange={(e) => {
                  let dateSvalue = e.value
                  if (dateSvalue) {
                    setSDate(dateSvalue);
                  } else {
                    setSDate(null);
                  }
                }}
              ></DatePickerComponent>
              <div className="errormessage">{validateInputMessage}</div>
            </div>
            <div className="selectTimeContainer1  d-flex align-items-center" style={{ zIndex: "auto" }}>
              {/* <div className="d-flex   justify-content-between gap-0"> */}
              <DatePickerComponent
                placeholder="To Date"
                width={300}
                min={sDate ? getNextDay(sDate) : today}
                isDateDisabled={disablePastDates}
                value={eDate}
                onChange={(e) => {
                  let dateEvalue = e.value
                  if (dateEvalue) {
                    setEDate(dateEvalue);
                  } else {
                    setEDate(null);
                  }
                }}
              ></DatePickerComponent>
              <div className="errormessage">{validateInputMessage}</div>
            </div>
          </div>
        )}

        {/*  */}
        <div className="d-flex gap-3 mt-3">
          <div className="selectTimeContainer  d-flex align-items-center" style={{ zIndex: "auto" }}>
            <div className="mainContain d-flex justify-content-between gap-2">
              <div className="outerDivTimepicker1cr d-flex align-items-center mr-5">
                {/* <DatePicker
                  selected={selectedTime}
                  onChange={handleTimeChange}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Start time"
                  dateFormat="h:mm aa"
                  placeholderText="Start time"
                  className="startTimeStudyPlanner"
                /> */}
                <TimePickerComponent
                  id="input_Select_time_inside"
                  format="hh:mm a"
                  placeholder="Start Time"
                  allowEdit={true}
                  value={selectedTime}
                  min={new Date(new Date().setHours(6, 0, 0, 0))}
                  onChange={(e) => {
                    let senputtime = e.value
                    setSTime(senputtime)
                    handleTimeChange(senputtime)
                  }

                  }
                />
                <div className="errormessage">{validateInputMessage}</div>
                {/* <div>
                  <img src="/DCM-img/DownArrow.png" alt="Up Arrow" />
                </div> */}
              </div>
              <div className="outerDivTimepickercr d-flex align-items-center">
                {/* <DatePicker
                  selected={selectedEndTime}
                  onChange={handleEndTimeChange}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="End time"
                  dateFormat="h:mm aa"
                  placeholderText="End time"
                  className="startTimeStudyPlanner"
                />
                <div>
                  <img src="/DCM-img/DownArrow.png" alt="Up Arrow" />
                </div> */}
                <TimePickerComponent
                  id="input_Select_time_inside"
                  format="hh:mm a"
                  placeholder="End Time"
                  allowEdit={true}
                  min={new Date(new Date().setHours(6, 0, 0, 0))}
                  value={selectedEndTime}
                  onChange={(e) => {
                    let eenputvalue = e.value
                    setETime(eenputvalue)
                    handleEndTimeChange(eenputvalue)
                  }
                  }
                />
                <div className="errormessage">{validateInputMessage}</div>
              </div>
            </div>
          </div>
          {repeat && (
            <div className="selectDayContainer  align-items-center p-2" style={{ zIndex: "auto" }}>
              <div
                onClick={handleSelectDayClick}
                className="d-flex align-items-center justify-content-between"
              >
                <div className="selectDay">
                  {selectedDays.length > 0
                    ? selectedDays.map((element) => ` ${element.slice(0, 3)},`)
                    : "Select day"}
                </div>
                <div>
                  {studyPlanner.selectDay ? (
                    <img src="/DCM-img/UpArrow.png" alt="Up Arrow" />
                  ) : (
                    <img src="/DCM-img/DownArrow.png" alt="Down Arrow" />
                  )}
                </div>
              </div>
              {studyPlanner.selectDay && (
                <div className="p-3">
                  <div className="d-flex gap-2">
                    <div
                      className={`weekDaysPlanner ${selectedDays.includes("Monday")
                        ? "weekDaysPlannerSelected"
                        : ""
                        } d-flex justify-content-center align-items-center`}
                      onClick={() => handleDayClick("Monday")}
                    >
                      M
                    </div>
                    <div
                      className={`weekDaysPlanner ${selectedDays.includes("Tuesday")
                        ? "weekDaysPlannerSelected"
                        : ""
                        } d-flex justify-content-center align-items-center`}
                      onClick={() => handleDayClick("Tuesday")}
                    >
                      T
                    </div>
                    <div
                      className={`weekDaysPlanner ${selectedDays.includes("Wednesday")
                        ? "weekDaysPlannerSelected"
                        : ""
                        } d-flex justify-content-center align-items-center`}
                      onClick={() => handleDayClick("Wednesday")}
                    >
                      W
                    </div>
                    <div
                      className={`weekDaysPlanner ${selectedDays.includes("Thursday")
                        ? "weekDaysPlannerSelected"
                        : ""
                        } d-flex justify-content-center align-items-center`}
                      onClick={() => handleDayClick("Thursday")}
                    >
                      Th
                    </div>
                    <div
                      className={`weekDaysPlanner ${selectedDays.includes("Friday")
                        ? "weekDaysPlannerSelected"
                        : ""
                        } d-flex justify-content-center align-items-center`}
                      onClick={() => handleDayClick("Friday")}
                    >
                      F
                    </div>
                    <div
                      className={`weekDaysPlanner ${selectedDays.includes("Saturday")
                        ? "weekDaysPlannerSelected"
                        : ""
                        } d-flex justify-content-center align-items-center`}
                      onClick={() => handleDayClick("Saturday")}
                    >
                      S
                    </div>
                    <div
                      className={`weekDaysPlanner ${selectedDays.includes("Sunday")
                        ? "weekDaysPlannerSelected"
                        : ""
                        } d-flex justify-content-center align-items-center`}
                      onClick={() => handleDayClick("Sunday")}
                    >
                      Su
                    </div>
                  </div>
                  <div>
                    <div className="form-check pt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox1"
                        value="option1"
                        checked={selectedDays.length === 7}
                        onChange={handleAllDaysClick}
                      />
                      <label
                        className="form-check-label AllDays"
                        htmlFor="inlineCheckbox1"
                      >
                        All Days
                      </label>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {!repeat && (
            <div className="selectDayContainer  align-items-center pl-2 pt-1">
              <DatePickerComponent
                min={today}
                isDateDisabled={disablePastDates}
                width={215}
                onChange={(e) => {
                  let datevalue = e.target.value
                  if (datevalue) {
                    setDate(datevalue);
                  } else {
                    setDate("");
                  }
                }}
                placeholder="Date"
              ></DatePickerComponent>
              <div className="errormessage">{validateInputMessage}</div>
            </div>
          )}
        </div>
        <input
          className="plannerSubject mt-3"
          placeholder="Study planner name"
          value={name}
          maxLength={20}
          onChange={(e) => {
            const value = e.target.value;
            const regex = /^[^\s]/;
            if (regex.test(value) || value === '') {
              handleInputName(value);
            }
          }}
        />
        <div className="errormessage">{validateInputMessage}</div>
        <textarea
          className="DescriptionPlanner mt-3"
          placeholder="Description"
          value={description}
          maxLength={250}
          onChange={(e) => {
            const value = e.target.value;
            const regex = /^[^\s]/;
            if (regex.test(value) || value === '') {
              handleInputDescription(value);
            }
          }}
        />
        <div className="errormessage">{validateInputMessage}</div>
        <div>
          <img
            className="crossIcon"
            onClick={studyPlannerDeactive}
            src="/DCM-img/crossIcon.svg"
            alt="Up Arrow"
          />
        </div>
        {errorMessage && <div className="errormessage">{errorMessage}</div>}
        <div className="d-flex justify-content-end mt-4">
          <button
            className={
              !(input && name && description && ((sDate && eDate && selectedDays.length > 0) || date) && sTime && eTime) || isClickedOnCreated
                ? "createPlannerBtnDsbl"
                : "createPlannerBtn"
            }
            disabled={!(input && name && description && ((sDate && eDate) || date) && sTime && eTime) || isClickedOnCreated}
            onClick={() => {
              let isCheckValidInput = handleValidateInputfield()
              if (isCheckValidInput) {
                handleStudyPlannerPublished();
              }
            }}
          >
            Create
          </button>
        </div>
      </div>}
      {showPopup && <StudyPlannerDatePopup setresErrorMessage={setresErrorMessage} message={resErrorMessage} setShowPop={setShowPop} />}
      {isSucess && <SucessfullyPublished />}
    </div >
  ) : (
    <StudyPlannerMultiple close={setOverlap} />
  );
}
